import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Text from '@deprecated-ui/common/Text';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';

import useAuthModalStore from 'features/securities/AuthModal/store';
import useSecuritiesCredentialStore from 'global/Securities/stores/useSecuritiesCredentialStore';
import useSearchCompanyModalStore from 'global/Securities/stores/useSearchCompanyModalStore';
import virtualTradingMenu from './virtualTradingMenu';
import { Grid, NavigationMobile } from './styled';
import { SwitchButton } from '../styled';

const VirtualTradeMobile = () => {
  const showAuthModal = useAuthModalStore((state) => state.showModal);
  const showSearchCompanyModal = useSearchCompanyModalStore((s) => s.showModal);

  const handleSwitchReal = async () => {
    await useSecuritiesCredentialStore.getState().loadLogout();
    showAuthModal();
  };

  return (
    <div style={{ padding: '16px' }}>
      <Flex align="center">
        <IconWrapper size="40px">
          <Image src="/icon/favicon.ico" />
        </IconWrapper>
        <Text>Virtual Area</Text>
      </Flex>
      <Button
        type="primary"
        margin="10px 0"
        height="36px"
        block
        onClick={showSearchCompanyModal}
      >
        <Text size="14px" color={color.light} align="center">
          BUY
        </Text>
      </Button>
      <Grid>
        {virtualTradingMenu[0].subMenu.map((subMenu) => (
          <NavigationMobile key={subMenu.label}>
            <Iconmoon
              className={subMenu.iconmoonMobile}
              color={color.dimgray}
              size="24px"
            />
            <Text as="a" size="11px" align="center" color={color.dimgray}>
              {subMenu.label}
            </Text>
          </NavigationMobile>
        ))}
      </Grid>
      <div style={{ padding: '0px 16px' }}>
        <SwitchButton height="32px" onClick={handleSwitchReal} block>
          <Text color={color.primary} size="14px" padding="0 8px">
            Switch to Real Account
          </Text>
        </SwitchButton>
      </div>
    </div>
  );
};

export default VirtualTradeMobile;
